import { useContext } from 'react';
import { UserStoreContext } from './UserStoreContext';
import type { UserStoreContextValue } from './UserStoreContext';

export const useUserStore = (): UserStoreContextValue => {
  const context = useContext(UserStoreContext);
  if (context === undefined) {
    throw new Error('useUserStore must be used within a UserStoreProvider');
  }
  return context;
};

